import { render, staticRenderFns } from "./chineseLanguageCourse.vue?vue&type=template&id=dbda221c&scoped=true&"
import script from "./chineseLanguageCourse.vue?vue&type=script&lang=js&"
export * from "./chineseLanguageCourse.vue?vue&type=script&lang=js&"
import style0 from "./chineseLanguageCourse.vue?vue&type=style&index=0&id=dbda221c&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dbda221c",
  null
  
)

export default component.exports